import { WorkflowActions, EntityTypeEnum, EntityState } from 'api'
import { userPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { AppThunk, movePrev, moveNext } from 'utils'

const PinAction = {
  MOVE_DOWN: 'MOVE_DOWN',
  MOVE_UP: 'MOVE_UP',
  MOVE_TO_TOP: 'MOVE_TO_TOP',
  MOVE_TO_BOTTOM: 'MOVE_TO_BOTTOM',
  UNPIN: 'UNPIN',
  PIN: 'PIN'
} as const

type PinAction = typeof PinAction[keyof typeof PinAction]

const updatePinned = (payload: { collateralId: string; type: PinAction }): AppThunk => async (dispatch, getState) => {
  const state = getState()
  const userPreference = userPreferenceSelector(state)

  dispatch(
    WorkflowActions.createEntitiesCreateAndSubmitReferenceData(
      [
        {
          data: {
            ...userPreference,
            pinnedCollaterals: pinnedCollateralsReducer(userPreference.pinnedCollaterals ?? [], payload)
          },
          entityState: EntityState.EXISTING,
          entityTypeEnum: EntityTypeEnum.USER_PREFERENCE,
          id: userPreference.id,
          validationIssues: []
        }
      ],
      []
    )
  )
}

const pinnedCollateralsReducer = (state: string[], action: { collateralId: string; type: PinAction }) => {
  switch (action.type) {
    case PinAction.PIN:
      return [...state, action.collateralId]
    case PinAction.UNPIN:
      return state.filter(id => id !== action.collateralId)
    case PinAction.MOVE_TO_TOP:
      return [action.collateralId, ...state.filter(id => id !== action.collateralId)]
    case PinAction.MOVE_TO_BOTTOM:
      return [...state.filter(id => id !== action.collateralId), action.collateralId]
    case PinAction.MOVE_UP:
      return movePrev(state, action.collateralId)
    case PinAction.MOVE_DOWN:
      return moveNext(state, action.collateralId)
    default:
      return state
  }
}

export const PinnedCollateralsThunks = {
  moveDown: (collateralId: string) => updatePinned({ collateralId, type: PinAction.MOVE_DOWN }),
  moveToBottom: (collateralId: string) => updatePinned({ collateralId, type: PinAction.MOVE_TO_BOTTOM }),
  moveToTop: (collateralId: string) => updatePinned({ collateralId, type: PinAction.MOVE_TO_TOP }),
  moveUp: (collateralId: string) => updatePinned({ collateralId, type: PinAction.MOVE_UP }),
  pin: (collateralId: string) => updatePinned({ collateralId, type: PinAction.PIN }),
  unpin: (collateralId: string) => updatePinned({ collateralId, type: PinAction.UNPIN })
}
